// extracted by mini-css-extract-plugin
module.exports = {"logo":"SideMenu_logo__2oyYe","sider":"SideMenu_sider__2fkHa","fixedSidebar":"SideMenu_fixedSidebar__1V_tm","light":"SideMenu_light__MzUvR","icon":"SideMenu_icon__28cJi"};